import { addAuthInterceptors } from '@dentalux/security';
import axios from 'axios';
const http = axios.create({
  baseURL: process.env.NEXT_PUBLIC_INSURANCE_URL
});
addAuthInterceptors(http);
export const getInsuranceCompanies = async () => {
  const {
    data
  } = await http.get('/insurance-companies');
  return data;
};
export const getQuotableStatus = async ({
  partner = 'privadent',
  personReferenceId
}) => {
  const {
    data
  } = await http.get(`/v1/external/insurance-partners/${partner}/persons/${personReferenceId}/quotable`);
  return data;
};
export const postSupplementaryOfferRequest = async ({
  languageCode = 'de',
  consentGiven,
  personReferenceId
}) => {
  const {
    data
  } = await http.post(`/v1/external/insurance-partners/privadent/persons/${personReferenceId}`, {
    consentGiven,
    languageCode
  });
  return data;
};